var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-new",on:{"click":_vm.show}},[_c('icon',{staticClass:"pencil-add",attrs:{"name":"pencil-add"}}),_c('span',[_vm._v("New Canvas")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }